import { render, staticRenderFns } from "./GlobalAllocationView.vue?vue&type=template&id=7651475c&scoped=true&"
import script from "./GlobalAllocationView.vue?vue&type=script&lang=ts&"
export * from "./GlobalAllocationView.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalAllocationView.vue?vue&type=style&index=0&id=7651475c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651475c",
  null
  
)

export default component.exports